module.exports = __webpack_public_path__ + "static/media/landscape-2.3e6d8e0b.png";